import { AjaxDataRequestOrder } from "./paginator";

export interface TableUpdateData {
    data: { [name: string]: any };
    allCheckedColumns: { [name: string]: boolean };
    modifications: any[];
    additions: any[];
    filterData: { [name: string]: any };
    currentFilterData?: { [name: string]: any };
    pagination?: {order: AjaxDataRequestOrder[]};
}

export function isTableUpdateData(arg: any): arg is TableUpdateData {
    return arg != null
        && arg.data !== undefined
        && arg.modifications !== undefined
        && arg.additions !== undefined;
}
